import { List, Record } from 'immutable'

import {
  TAB_T1_INVITATIONS,
  TAB_T1_REMINDERS,
  TAB_T1_REPORT,
  TAB_T2_INVITATION,
  TAB_T2_INVITATIONS,
  TAB_T2_REMINDER,
  TAB_T2_REMINDERS,
  TAB_T2_REPORT,
} from 'app/constants/reviews'

export const Messaging = Record({
  subject: null,
  image: null,
  text: null,
})

export const ReviewsMessaging = Record({
  [TAB_T1_INVITATIONS]: new Messaging(),
  [TAB_T1_REMINDERS]: new Messaging(),
  [TAB_T2_INVITATIONS]: new Messaging(),
  [TAB_T2_REMINDERS]: new Messaging(),
  [TAB_T2_INVITATION]: new Messaging(),
  [TAB_T2_REMINDER]: new Messaging(),
  [TAB_T1_REPORT]: new Messaging(),
  [TAB_T2_REPORT]: new Messaging(),
})

export const ReviewsUser = Record({
  id: null,
  firstName: null,
  lastName: null,
  email: null,
  teams: List(),
  t1Self: false,
  t1Superior: List(),
  t1Peer: List(),
  t1Employee: List(),
  t2Self: false,
  t2Superior: List(),
  t2Peer: List(),
  t2Employee: List(),
  t1ReportCreated: false,
  t2ReportCreated: false,
  isT2SelfInvitationSent: false,
  roles: List(),
})

export const ReviewersUser = Record({
  firstName: null,
  lastName: null,
  email: null,
  isComplete: false,
})
